"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _iconNames = _interopRequireDefault(require("../../../constants/iconNames"));

var _button = require("../../../styles/2_commonComponentStyles/button");

var _IconBubbleButton = require("./IconBubbleButton.styles");

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * IconBubbleButton - for when you need the IconBubble to be interactive
 */
// intentionally left as a functional component
var IconBubbleButton = function IconBubbleButton(_ref) {
  var iconName = _ref.iconName,
      onClick = _ref.onClick,
      text = _ref.text,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["iconName", "onClick", "text", "value"]);

  var localOnClickHandler = function localOnClickHandler(evt) {
    onClick(_lodash.default.merge(evt, {
      target: {
        value: value
      }
    }));
  };

  var content = iconName ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    iconName: iconName,
    dataTestId: "icon-bubble-button-icon"
  }) : /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "icon-bubble-button-text"
  }, text);
  return /*#__PURE__*/_react.default.createElement(_IconBubbleButton.StyledIconBubbleButton, _extends({}, props, {
    onClick: localOnClickHandler
  }), content);
};

IconBubbleButton.propTypes = {
  /** active state for button toggling */
  active: _propTypes.default.bool,

  /** Height options for when we need something other than our rather large default button */
  buttonHeight: _propTypes.default.oneOf([undefined, 'small', 'medium', 'large']),

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** colorTheme */
  colorTheme: _propTypes.default.oneOf(_button.buttonColorThemes),

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** disabled handles button interactivity */
  disabled: _propTypes.default.bool,

  /** iconName - reflects string name of fontawesome icon - see 'constants/iconNames' for the full list */
  iconName: _propTypes.default.oneOf(_iconNames.default),

  /** onClick handler for button interaction */
  onClick: _propTypes.default.func.isRequired,

  /** text - text layed on top of the button */
  text: _propTypes.default.string,
  value: _propTypes.default.string
};
IconBubbleButton.defaultProps = {
  active: false,
  buttonHeight: undefined,
  className: '',
  colorTheme: 'primary',
  disabled: false,
  iconName: '',
  text: '',
  value: ''
};
var _default = IconBubbleButton;
exports.default = _default;